var _style, _polygon, _polygon2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuickCoupler(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgcontent",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.quickCoupler-st0{fill:#FFFFFF;stroke:currentColor;stroke-miterlimit:30;}\r\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "svg_2_00000006698894727627678160000001222845727458132363_",
    className: "quickCoupler-st0",
    points: "3.1,33 52.8,33 52.8,46.8 3.1,46.8 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "78,33.9 52.8,33.6 52.8,46.3 78,45.9 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickCoupler);
export default __webpack_public_path__ + "static/media/quickCoupler.fc504fad2a9ffcd053f92f059390c04d.svg";
export { ForwardRef as ReactComponent };